import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M3875 9305 c-39 -21 -45 -32 -45 -82 0 -35 4 -44 30 -60 83 -53 183
48 119 120 -31 34 -66 41 -104 22z"
          />
          <path d="M4133 9243 c26 -2 67 -2 90 0 23 2 2 3 -48 3 -49 0 -68 -1 -42 -3z" />
          <path d="M7558 9033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M3841 9004 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M7710 8986 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
          <path
            d="M7785 8940 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"
          />
          <path
            d="M2920 8925 c-14 -8 -20 -14 -15 -14 6 0 21 6 35 14 14 8 21 14 15 14
-5 0 -21 -6 -35 -14z"
          />
          <path
            d="M7854 8895 c20 -14 40 -25 43 -25 4 0 -8 11 -27 25 -19 14 -38 25
-43 25 -6 0 7 -11 27 -25z"
          />
          <path
            d="M2855 8889 c-16 -10 -25 -19 -19 -19 7 0 22 9 35 20 30 24 23 24 -16
-1z"
          />
          <path
            d="M4473 8858 c-20 -26 -21 -57 -1 -77 25 -27 53 -27 72 1 22 30 20 46
-6 69 -27 21 -52 24 -65 7z m47 -18 c0 -5 8 -10 18 -11 10 0 12 -3 5 -6 -7 -2
-23 3 -35 11 -18 13 -19 16 -5 16 9 0 17 -4 17 -10z"
          />
          <path
            d="M7910 8860 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"
          />
          <path
            d="M7328 8849 c-11 -6 -18 -22 -18 -39 0 -38 41 -70 89 -70 38 -1 113
-23 196 -60 112 -50 251 -178 321 -296 53 -90 79 -162 99 -271 9 -48 18 -98
20 -110 11 -48 99 -45 112 5 16 66 -28 254 -89 377 -55 109 -150 224 -252 303
-68 52 -185 114 -199 105 -6 -3 -7 -2 -4 4 4 6 -24 19 -66 32 -83 24 -114 27
-77 6 l25 -14 -37 -1 c-20 0 -44 -3 -54 -7 -14 -5 -16 -3 -11 11 6 15 3 17
-13 13 -27 -7 -25 1 3 13 22 9 22 9 -3 9 -14 0 -33 -4 -42 -10z"
          />
          <path
            d="M8080 8851 c0 -4 9 -20 20 -34 11 -14 20 -30 20 -35 0 -6 9 -14 20
-17 11 -3 25 -16 31 -28 9 -19 8 -20 -3 -6 -8 9 -22 18 -33 20 -11 3 -21 14
-23 26 -2 12 -9 24 -16 26 -10 4 -12 -1 -9 -14 6 -21 -7 -25 -25 -7 -17 17
-16 -13 1 -32 6 -8 2 -6 -11 5 -12 10 -20 25 -18 32 6 14 4 15 -36 17 -26 2
-25 1 15 -40 117 -117 213 -271 266 -431 25 -75 51 -219 51 -284 0 -40 4 -51
27 -68 29 -24 56 -21 87 9 18 18 19 25 7 120 -16 128 -42 232 -88 340 -45 105
-102 202 -116 193 -6 -3 -7 -1 -3 5 4 6 -10 33 -30 59 -45 60 -134 156 -134
144z m40 -132 c0 -5 -4 -9 -10 -9 -5 0 -10 7 -10 16 0 8 5 12 10 9 6 -3 10
-10 10 -16z m30 -19 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0
4 -4 4 -10z"
          />
          <path
            d="M2749 8819 c-23 -19 -23 -20 -2 -10 12 6 25 16 28 21 10 16 -1 12
-26 -11z"
          />
          <path
            d="M2574 8801 c-17 -11 -34 -31 -38 -46 -7 -27 2 -100 12 -91 2 3 14 -1
26 -9 11 -8 28 -15 37 -15 10 0 20 -8 22 -17 4 -15 5 -16 6 -2 0 9 12 24 25
32 13 9 31 29 39 45 19 39 1 84 -42 106 -39 20 -49 20 -87 -3z"
          />
          <path
            d="M3657 8739 c-62 -47 -69 -117 -16 -173 20 -21 25 -34 18 -45 -13 -23
-188 -408 -209 -461 -11 -25 -52 -119 -92 -210 l-74 -165 -39 -7 c-51 -8 -46
-13 -279 273 -159 195 -182 227 -173 244 19 36 24 90 11 103 -7 6 -17 19 -22
28 -5 8 -27 18 -50 21 -23 3 -42 11 -43 17 -1 29 -47 228 -48 210 -1 -12 8
-66 19 -119 11 -53 20 -100 20 -104 0 -4 -11 -13 -24 -21 -29 -15 -51 -61 -43
-90 4 -16 -4 -26 -34 -45 -21 -14 -41 -25 -45 -25 -8 0 -219 -115 -407 -222
-76 -43 -141 -78 -144 -78 -3 0 -14 9 -24 21 -17 20 -17 22 25 92 126 213 253
377 427 550 48 48 84 87 80 87 -7 0 -155 -144 -213 -207 -104 -115 -286 -373
-329 -468 -12 -26 -19 -30 -46 -27 -75 8 -143 -62 -128 -130 10 -42 61 -88 99
-88 78 0 116 38 116 116 l0 42 218 120 c305 168 404 222 408 222 2 0 14 -10
26 -22 l22 -22 -33 -60 c-18 -34 -80 -155 -138 -271 -58 -115 -116 -230 -130
-255 -13 -25 -29 -57 -34 -72 -8 -21 -17 -27 -37 -26 -15 1 -43 -1 -62 -5 -34
-6 -37 -5 -115 88 -44 53 -96 110 -115 128 -45 41 -6 -6 174 -210 17 -21 18
-27 6 -62 -10 -30 -10 -46 0 -75 13 -39 17 -30 -70 -125 -8 -9 -73 -86 -143
-171 -71 -85 -109 -134 -85 -109 23 25 87 97 141 160 183 215 172 204 202 191
32 -15 70 -15 97 -1 14 8 23 8 31 0 6 -6 16 -11 22 -11 5 0 3 4 -5 10 -12 7
-12 14 -2 43 18 50 15 76 -14 114 l-26 34 170 337 170 337 39 5 c21 3 44 9 51
14 13 8 20 1 105 -105 28 -36 114 -141 190 -232 76 -92 135 -172 132 -177 -23
-36 -22 -68 1 -95 66 -77 189 17 125 96 -21 26 -20 28 27 131 17 35 49 106 72
158 23 52 50 113 60 135 15 33 62 139 120 270 87 196 87 195 119 189 85 -17
159 83 120 159 -34 65 -117 87 -172 46z"
          />
          <path
            d="M3098 8724 c-24 -13 -26 -17 -16 -34 14 -22 38 -26 56 -8 8 8 50 8
172 -1 89 -7 163 -11 166 -9 5 5 -230 28 -283 28 -22 0 -36 6 -43 20 -13 24
-16 24 -52 4z"
          />
          <path d="M2748 8723 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
          <path d="M2908 8713 c17 -2 47 -2 65 0 17 2 3 4 -33 4 -36 0 -50 -2 -32 -4z" />
          <path d="M3988 8703 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M3948 8693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M3870 8680 c-20 -6 -21 -8 -5 -8 11 0 31 4 45 8 20 6 21 8 5 8 -11 0
-31 -4 -45 -8z"
          />
          <path d="M3513 8663 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" />
          <path
            d="M3345 8499 c-110 -44 -207 -82 -215 -85 -125 -48 -270 -107 -267
-110 3 -4 289 102 367 136 25 11 110 45 190 76 80 30 147 58 149 60 15 14 -48
-7 -224 -77z"
          />
          <path d="M2965 8560 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
          <path
            d="M4433 8513 c-163 -318 -521 -1043 -564 -1138 -5 -11 -13 -27 -19 -35
-10 -15 -176 -361 -303 -630 -19 -41 -71 -151 -116 -244 -45 -92 -81 -169 -81
-171 0 -10 429 -255 448 -255 7 0 24 24 36 53 13 28 43 93 66 142 23 50 55
117 70 150 35 75 92 198 137 295 38 81 188 406 258 560 114 252 148 325 150
328 4 5 47 -89 208 -448 36 -80 76 -170 90 -200 14 -30 48 -107 77 -170 65
-145 131 -289 186 -409 24 -51 44 -95 44 -96 0 -3 114 -257 175 -390 12 -27
39 -88 60 -135 90 -205 128 -286 139 -297 23 -25 637 -161 681 -151 9 2 -4 40
-43 123 -100 212 -140 299 -160 345 -11 25 -44 97 -75 160 -30 63 -113 241
-185 395 -189 407 -249 533 -439 925 -58 118 -155 319 -215 445 -145 301 -405
817 -420 830 -8 7 -9 5 -3 -10 16 -44 18 -58 7 -51 -7 4 -15 0 -19 -10 -6 -16
-7 -16 -19 1 -13 17 -14 17 -20 -1 -3 -10 -10 -29 -15 -42 -5 -13 -9 -36 -9
-51 0 -18 -10 -39 -29 -57 -47 -48 -59 -55 -96 -56 -28 -1 -35 -5 -35 -21 0
-37 -12 -9 -13 30 0 21 -2 30 -4 21 -3 -10 -9 -18 -15 -18 -11 0 -2 48 17 95
46 107 89 235 82 241 -3 3 -18 -21 -34 -53z m-61 -310 c-5 -10 -7 -24 -5 -30
3 -7 -3 -13 -12 -13 -12 0 -15 5 -9 23 6 18 21 36 32 37 1 0 -1 -8 -6 -17z"
          />
          <path
            d="M6190 8544 c-317 -41 -558 -162 -731 -367 -145 -173 -230 -441 -200
-630 13 -76 27 -110 153 -364 81 -165 97 -189 157 -247 156 -153 317 -239 731
-392 329 -122 358 -133 505 -198 337 -149 543 -352 621 -611 24 -78 24 -287 1
-357 -8 -27 -11 -48 -6 -48 18 0 93 42 155 86 58 41 61 45 82 116 40 142 47
184 46 308 0 432 -237 783 -669 990 -115 55 -202 90 -515 205 -344 127 -443
173 -556 256 -314 231 -229 630 157 736 100 28 346 25 459 -6 95 -25 225 -83
294 -131 26 -17 51 -28 56 -25 6 4 20 25 31 48 53 104 148 255 187 296 34 36
40 47 30 58 -7 7 -62 41 -121 77 -158 95 -330 158 -507 186 -74 11 -307 20
-360 14z"
          />
          <path
            d="M7327 8530 c-15 -12 -27 -30 -27 -41 0 -31 42 -65 89 -73 66 -10 140
-53 202 -116 77 -79 106 -143 135 -297 8 -43 90 -47 113 -5 16 30 -5 146 -43
225 -62 134 -162 233 -293 287 -100 41 -143 46 -176 20z"
          />
          <path
            d="M2831 8413 c-22 -26 -41 -51 -41 -56 0 -4 20 15 45 43 42 47 51 60
41 60 -2 0 -22 -21 -45 -47z"
          />
          <path d="M4444 8255 c-18 -14 -18 -14 9 -15 15 0 27 4 27 9 0 18 -17 20 -36 6z" />
          <path
            d="M7243 8134 c-56 -37 -87 -95 -86 -161 0 -63 24 -106 82 -150 35 -27
51 -33 94 -33 145 0 238 139 177 265 -34 70 -79 99 -159 103 -58 3 -71 0 -108
-24z"
          />
          <path
            d="M1805 7637 c-29 -66 -95 -274 -94 -296 1 -18 6 -3 44 122 14 48 39
119 55 157 34 82 30 95 -5 17z"
          />
          <path
            d="M3050 7559 c-55 -15 -58 -17 -20 -12 52 6 134 31 105 31 -11 0 -49
-8 -85 -19z"
          />
          <path
            d="M2835 7510 c-60 -16 -92 -27 -70 -24 52 7 226 52 200 52 -11 1 -69
-12 -130 -28z"
          />
          <path
            d="M2599 7456 c-102 -25 -146 -39 -89 -30 50 8 204 45 209 50 8 8 -24 2
-120 -20z"
          />
          <path d="M2438 7413 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M1696 7289 c-8 -42 0 -50 9 -9 4 17 5 34 2 36 -2 3 -7 -10 -11 -27z" />
          <path
            d="M1672 7186 c-7 -33 -12 -71 -11 -85 0 -14 7 6 15 44 8 39 13 77 11
85 -1 8 -8 -12 -15 -44z"
          />
          <path d="M2264 7020 c0 -107 2 -151 3 -97 2 53 2 141 0 195 -1 53 -3 9 -3 -98z" />
          <path d="M8908 7123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M1653 7030 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
          <path d="M8810 7007 l5 -52 3 44 c2 24 0 47 -5 52 -4 4 -6 -15 -3 -44z" />
          <path
            d="M9006 7042 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"
          />
          <path
            d="M8210 6948 c-41 -40 -151 -147 -245 -238 -221 -215 -260 -251 -282
-254 -29 -5 -21 -31 10 -34 25 -3 59 27 312 282 l284 286 128 1 c70 0 151 4
178 8 l50 7 -64 7 c-35 4 -116 7 -180 7 l-116 0 -75 -72z"
          />
          <path
            d="M8745 7010 c-19 -8 -19 -9 3 -9 12 -1 22 4 22 9 0 6 -1 10 -2 9 -2 0
-12 -4 -23 -9z"
          />
          <path
            d="M3005 6993 c-212 -14 -411 -68 -506 -138 -62 -45 -104 -127 -96 -187
12 -88 97 -208 230 -323 38 -33 74 -64 81 -70 86 -76 503 -351 609 -401 20
-10 37 -21 37 -26 0 -4 5 -8 10 -8 6 0 67 -32 138 -71 272 -153 684 -348 1017
-481 83 -33 164 -66 180 -73 33 -14 91 -34 395 -137 l205 -69 105 -95 c253
-228 490 -349 780 -400 118 -20 376 -15 490 11 115 25 246 72 343 123 96 50
130 77 78 62 -59 -17 -297 -32 -401 -25 -260 16 -497 57 -860 149 -341 86
-507 142 -486 163 2 2 23 -4 47 -13 37 -13 166 -49 309 -85 43 -11 273 -59
315 -66 17 -3 82 -13 145 -23 200 -33 359 -43 578 -37 209 6 327 20 483 57
295 70 528 203 663 379 76 99 110 188 120 311 3 36 5 66 5 66 1 1 20 4 43 7
37 5 56 20 192 156 l151 151 63 0 c47 0 62 -3 62 -14 0 -22 49 -56 81 -56 32
0 76 38 85 75 10 38 -25 88 -68 99 -41 10 -86 -11 -95 -45 -5 -16 -15 -19 -72
-19 l-66 0 -140 -138 c-181 -178 -255 -229 -255 -175 0 9 -7 40 -17 69 l-16
52 32 40 c17 22 104 113 193 201 l161 161 396 0 396 0 19 -35 c13 -23 30 -38
51 -44 71 -19 124 17 132 91 4 38 1 48 -25 76 -52 55 -130 41 -167 -29 l-14
-27 -401 5 -401 6 -168 -167 c-92 -91 -175 -166 -183 -166 -8 0 -23 -9 -33
-20 -10 -11 -21 -20 -25 -20 -3 0 -28 31 -54 69 -26 38 -54 75 -63 83 -15 12
-16 8 -10 -36 4 -28 19 -84 33 -125 81 -233 -11 -405 -291 -544 -262 -130
-629 -179 -1104 -147 -281 19 -816 123 -1111 215 -203 64 -547 178 -641 213
-685 255 -1298 580 -1685 893 -140 114 -234 241 -234 319 0 44 36 104 80 135
48 33 162 72 252 86 40 6 75 13 77 15 5 4 -91 3 -174 -3z m6295 -773 c30 -30
27 -83 -6 -109 -15 -12 -34 -21 -44 -21 -10 0 -29 9 -44 21 -30 24 -35 72 -10
107 20 29 76 30 104 2z m-647 -271 c15 -21 17 -31 8 -48 -25 -46 -92 -46 -104
1 -18 67 54 102 96 47z"
          />
          <path d="M1643 6930 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z" />
          <path d="M9001 6964 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M8825 6930 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"
          />
          <path
            d="M8955 6915 c-16 -7 -46 -11 -65 -9 -33 4 -33 4 -10 -6 30 -13 83 -5
100 15 14 17 14 17 -25 0z"
          />
          <path
            d="M1773 6813 c-43 -52 -57 -73 -49 -73 3 0 26 27 51 60 55 72 54 79 -2
13z"
          />
          <path
            d="M8516 6769 c-14 -17 -26 -35 -26 -40 0 -5 -46 -9 -102 -9 l-103 0
-226 -226 c-209 -208 -229 -226 -268 -231 -42 -6 -46 -9 -33 -30 5 -8 21 -9
51 -3 40 7 62 26 265 229 l221 221 95 0 95 0 17 -30 c20 -36 74 -62 109 -53
34 8 77 51 84 84 13 59 -44 119 -114 119 -32 0 -44 -6 -65 -31z m118 -10 c35
-27 37 -90 4 -113 -48 -34 -118 -8 -118 44 0 43 10 61 44 76 40 17 39 17 70
-7z"
          />
          <path
            d="M1615 6741 c-66 -27 -79 -105 -27 -152 54 -48 122 -32 142 33 14 47
-8 103 -45 112 -13 3 -29 8 -37 10 -7 3 -22 1 -33 -3z"
          />
          <path d="M5900 6636 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
          <path
            d="M5990 6591 c19 -11 116 -53 215 -96 549 -234 791 -394 887 -587 58
-116 71 -220 42 -337 -33 -131 -112 -246 -215 -312 -27 -18 -47 -34 -45 -37
14 -13 373 42 441 68 29 11 39 26 61 95 15 46 19 89 19 190 0 124 -1 134 -33
209 -36 86 -119 211 -179 267 -125 119 -334 236 -573 324 -69 25 -147 54 -175
64 -27 11 -81 29 -120 41 -38 13 -132 47 -208 76 -146 57 -175 65 -117 35z"
          />
          <path
            d="M1731 6567 c2 -1 13 -9 24 -17 19 -14 19 -14 6 3 -7 9 -18 17 -24 17
-6 0 -8 -1 -6 -3z"
          />
          <path
            d="M1786 6522 c5 -4 23 -18 39 -32 l30 -25 -29 33 c-17 17 -34 32 -40
32 -6 0 -6 -3 0 -8z"
          />
          <path
            d="M9620 6508 c8 -8 21 -20 29 -28 12 -12 11 -10 0 9 -9 14 -22 27 -30
29 -11 3 -11 1 1 -10z"
          />
          <path d="M1652 6450 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
          <path
            d="M1890 6435 c19 -19 36 -35 39 -35 3 0 -10 16 -29 35 -19 19 -36 35
-39 35 -3 0 10 -16 29 -35z"
          />
          <path
            d="M9483 6455 c0 -8 4 -15 9 -15 4 0 8 7 8 15 0 8 -4 15 -8 15 -5 0 -9
-7 -9 -15z"
          />
          <path
            d="M8099 6245 c-173 -172 -200 -195 -228 -195 l-32 0 18 -30 c9 -16 22
-30 28 -30 5 0 104 94 220 210 l210 209 475 5 c261 2 498 8 525 14 35 6 -109
10 -485 11 l-535 1 -196 -195z"
          />
          <path
            d="M9440 6429 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
          />
          <path
            d="M9490 6402 c0 -51 95 -80 143 -42 15 12 27 26 27 32 0 5 -14 -2 -31
-16 -17 -14 -39 -26 -50 -26 -26 0 -69 29 -69 46 0 7 -4 16 -10 19 -5 3 -10
-2 -10 -13z"
          />
          <path
            d="M1666 6350 c5 -54 32 -170 33 -140 0 8 -9 56 -19 105 -15 71 -18 78
-14 35z"
          />
          <path
            d="M1955 6380 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"
          />
          <path d="M2019 6327 c36 -39 41 -42 41 -29 0 4 -17 20 -38 36 l-37 29 34 -36z" />
          <path
            d="M4195 6268 c-7 -18 -45 -98 -84 -177 -39 -79 -68 -148 -65 -153 3 -4
40 -24 82 -43 l76 -36 470 1 c258 0 471 2 473 3 4 4 -47 124 -94 222 -22 44
-52 110 -69 147 l-29 67 -373 1 -373 0 -14 -32z"
          />
          <path
            d="M2085 6272 c11 -13 29 -28 40 -34 21 -11 18 -8 -30 32 -29 24 -29 24
-10 2z"
          />
          <path
            d="M2168 6199 c17 -20 21 -33 16 -57 -8 -38 11 -89 38 -103 13 -7 17
-17 13 -32 -5 -19 -5 -20 5 -4 8 12 24 17 54 17 35 0 45 4 56 25 7 14 16 25
20 25 5 0 6 27 2 71 -3 24 -48 66 -78 72 -14 2 -41 -4 -61 -14 -37 -19 -37
-19 -62 4 l-26 22 23 -26z"
          />
          <path
            d="M8177 6162 c-38 -38 -45 -52 -27 -52 16 0 80 61 80 76 0 23 -14 16
-53 -24z"
          />
          <path d="M1711 6124 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M1720 6093 c0 -17 31 -115 35 -111 5 5 -21 108 -29 116 -3 3 -6 1 -6
-5z"
          />
          <path
            d="M8080 6068 c-21 -23 -26 -38 -11 -38 13 0 61 40 61 51 0 17 -29 9
-50 -13z"
          />
          <path
            d="M2480 6025 c14 -8 30 -14 35 -14 6 0 -1 6 -15 14 -14 8 -29 14 -35
14 -5 0 1 -6 15 -14z"
          />
          <path
            d="M2381 5963 c7 -12 15 -20 18 -17 3 2 -3 12 -13 22 -17 16 -18 16 -5
-5z"
          />
          <path
            d="M1760 5962 c0 -16 61 -175 65 -170 2 2 -11 44 -30 93 -19 50 -34 84
-35 77z"
          />
          <path
            d="M2424 5897 c16 -20 30 -37 33 -37 7 0 -36 58 -49 66 -7 4 1 -9 16
-29z"
          />
          <path
            d="M2177 5868 c-26 -63 -28 -84 -2 -29 14 30 23 56 21 59 -3 2 -11 -11
-19 -30z"
          />
          <path
            d="M3129 5808 c-18 -35 -65 -133 -104 -218 -79 -168 -226 -478 -325
-685 -103 -216 -110 -232 -110 -238 0 -4 127 -7 283 -7 l283 0 69 148 c38 81
111 234 162 340 51 106 93 195 93 197 0 2 26 57 58 122 32 65 61 126 64 135 5
13 -19 30 -115 84 -67 37 -165 93 -219 126 -53 32 -99 58 -102 58 -3 0 -20
-28 -37 -62z"
          />
          <path
            d="M2490 5806 c19 -26 39 -50 44 -54 5 -3 -6 16 -24 42 -19 26 -39 50
-44 54 -5 3 6 -16 24 -42z"
          />
          <path
            d="M1830 5775 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"
          />
          <path d="M2136 5765 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z" />
          <path
            d="M2551 5723 c7 -12 15 -20 18 -17 3 2 -3 12 -13 22 -17 16 -18 16 -5
-5z"
          />
          <path
            d="M1852 5722 c23 -53 92 -182 95 -178 5 5 -85 186 -93 186 -3 0 -4 -3
-2 -8z"
          />
          <path
            d="M2100 5667 c-61 -160 -59 -157 -99 -157 -30 0 -40 -6 -59 -35 -41
-58 -12 -120 61 -132 31 -5 40 -1 67 26 30 30 33 31 76 20 25 -7 48 -9 51 -5
4 3 0 6 -8 6 -8 0 -31 5 -51 10 -29 8 -38 17 -43 41 -4 16 -15 38 -26 48 -19
18 -19 19 6 87 14 38 33 86 42 107 9 20 14 39 12 42 -3 2 -15 -24 -29 -58z"
          />
          <path
            d="M9692 5679 c-13 -5 -29 -22 -35 -39 l-11 -30 -156 0 -157 0 -57 -60
-58 -60 -327 0 -326 0 -200 -200 -200 -200 -106 0 c-93 0 -108 -2 -124 -20
-18 -20 -17 -20 113 -20 l130 0 203 205 203 205 329 0 329 -1 50 55 50 56 149
0 148 0 16 -30 c42 -81 167 -66 189 23 22 88 -62 152 -152 116z m101 -36 c28
-31 30 -66 7 -96 -25 -32 -73 -37 -102 -10 -23 20 -24 80 -1 105 21 23 75 24
96 1z"
          />
          <path
            d="M8305 5540 c-110 -110 -145 -140 -169 -142 -45 -4 -49 -38 -5 -38 29
0 50 18 176 145 l144 145 379 0 c331 0 380 2 380 15 0 13 -49 15 -383 15
l-382 0 -140 -140z"
          />
          <path
            d="M2660 5576 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"
          />
          <path d="M2218 5373 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M2370 5334 c69 -18 129 -32 135 -31 11 4 -225 67 -246 66 -8 0 42
-16 111 -35z"
          />
          <path
            d="M2104 5288 c14 -18 34 -44 44 -58 9 -13 37 -45 60 -70 24 -25 7 1
-38 58 -45 56 -84 102 -87 102 -3 0 6 -15 21 -32z"
          />
          <path d="M2588 5283 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M9380 5283 c-19 -8 -32 -21 -54 -55 l-18 -28 -297 0 -296 -1 -173
-169 -173 -170 -349 0 c-337 0 -400 -5 -400 -31 0 -8 100 -10 386 -7 l386 5
172 172 172 171 287 0 286 0 16 -29 c21 -41 53 -61 96 -61 73 0 125 79 94 145
-24 50 -86 77 -135 58z m93 -55 c24 -28 21 -65 -8 -93 -27 -28 -42 -30 -80
-13 -47 21 -44 100 5 125 30 15 59 8 83 -19z"
          />
          <path
            d="M8885 5110 c-3 -5 -34 -10 -68 -10 l-62 0 -138 -138 c-122 -122 -154
-162 -130 -162 4 0 69 60 143 134 l135 134 110 6 c61 3 111 5 113 6 1 0 2 6 2
14 0 8 -15 16 -37 20 -52 8 -61 8 -68 -4z"
          />
          <path
            d="M3470 4796 c0 -3 15 -15 33 -27 23 -17 28 -18 18 -6 -14 18 -51 42
-51 33z"
          />
          <path
            d="M4192 4788 c-18 -18 -15 -41 7 -55 26 -16 54 5 49 38 -3 27 -36 37
-56 17z"
          />
          <path
            d="M8693 4755 l-28 -35 -628 0 c-579 0 -630 -1 -660 -17 -31 -17 -7 -18
636 -21 568 -2 667 -4 667 -16 0 -21 49 -56 77 -56 41 0 82 31 89 66 12 65
-25 114 -87 114 -32 0 -43 -6 -66 -35z m105 -11 c28 -19 28 -53 2 -82 -38 -40
-90 -18 -90 38 0 53 44 75 88 44z"
          />
          <path
            d="M3630 4726 c-14 -8 -27 -13 -30 -11 -5 3 -6 -52 -2 -83 1 -7 17 -20
36 -28 29 -14 37 -15 61 -3 16 8 34 28 41 45 11 27 10 33 -9 57 -27 32 -64 41
-97 23z"
          />
          <path d="M4018 4723 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M3968 4713 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M3928 4703 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path d="M3820 4690 c-20 -6 -21 -8 -5 -8 11 0 29 3 40 8 25 11 -1 11 -35 0z" />
          <path
            d="M1036 3798 c-28 -63 -195 -429 -295 -647 -39 -85 -71 -158 -71 -163
0 -5 38 -7 85 -6 l86 3 45 100 c25 55 52 114 59 130 125 276 178 391 184 398
7 7 88 -160 163 -332 12 -30 48 -109 79 -175 l55 -121 88 -3 c86 -3 87 -2 81
19 -4 12 -92 207 -196 433 l-188 411 -76 3 -76 3 -23 -53z"
          />
          <path
            d="M1744 3837 c-6 -16 11 -47 59 -109 l29 -38 201 0 c266 0 297 -14 297
-137 0 -44 -5 -58 -29 -85 l-29 -33 -269 -5 -268 -5 0 -220 0 -220 80 0 80 0
3 143 3 142 108 0 108 0 59 -86 c33 -47 78 -112 102 -145 l42 -59 85 0 c50 0
85 4 85 10 0 10 -110 175 -162 241 -15 20 -28 41 -28 45 0 5 20 17 45 28 55
22 121 94 137 150 7 23 12 73 12 112 0 119 -56 208 -164 258 -41 19 -67 21
-312 24 -231 3 -269 2 -274 -11z"
          />
          <path
            d="M2637 3843 c-9 -8 -9 -790 -1 -832 l7 -31 78 0 79 0 0 180 0 180 220
0 220 0 2 -177 3 -178 80 0 80 0 0 430 0 430 -80 0 -80 0 -3 -172 -2 -173
-220 0 -220 0 0 175 0 175 -78 0 c-43 0 -82 -3 -85 -7z"
          />
          <path
            d="M3942 3844 c-7 -3 -24 -29 -37 -58 -104 -230 -147 -323 -249 -545
-64 -139 -116 -255 -116 -258 0 -2 38 -2 85 -1 l86 3 68 150 c37 83 82 179 98
215 17 36 52 113 78 173 26 59 50 105 53 102 3 -2 31 -58 64 -122 50 -102 69
-127 43 -58 -7 16 -4 16 15 -5 l22 -25 -7 25 c-7 22 -6 23 9 11 14 -12 16 -11
16 9 0 19 2 21 16 9 13 -11 14 -9 9 14 -9 33 8 36 23 5 6 -13 11 -17 11 -10 1
15 -23 77 -82 212 -13 30 -32 76 -43 102 -14 36 -24 48 -40 48 -12 0 -41 2
-65 5 -24 2 -50 2 -57 -1z"
          />
          <path
            d="M4604 3835 c-4 -8 11 -43 33 -78 l39 -62 184 -5 c166 -5 189 -8 227
-27 183 -98 176 -418 -12 -504 -32 -15 -66 -19 -177 -19 l-138 0 -2 178 -3
177 -75 0 -75 0 -3 -258 -2 -259 242 4 243 3 70 33 c82 39 151 107 191 188 40
82 53 214 30 314 -28 126 -109 231 -222 288 -62 32 -150 42 -357 42 -158 0
-189 -2 -193 -15z"
          />
          <path
            d="M5786 3778 c-39 -86 -44 -95 -220 -485 -75 -166 -136 -304 -136 -307
0 -4 39 -5 86 -4 l86 3 45 100 c25 55 58 127 73 160 15 33 35 76 43 95 74 165
105 238 111 258 4 12 11 22 15 22 3 0 38 -69 75 -152 38 -84 103 -228 144
-320 l76 -168 88 0 c48 0 88 2 88 4 0 3 -133 299 -192 426 -65 140 -185 406
-191 423 -5 14 -19 17 -82 17 l-76 0 -33 -72z"
          />
          <path
            d="M6317 3778 c-2 -40 -3 -76 0 -80 2 -5 60 -8 129 -8 l124 0 0 -355 0
-356 83 3 82 3 3 352 2 352 133 3 132 3 0 75 0 75 -341 3 -341 2 -6 -72z"
          />
          <path
            d="M8140 3841 c-76 -23 -138 -80 -161 -148 -21 -59 -16 -170 9 -219 28
-55 93 -109 147 -123 24 -6 97 -11 163 -11 161 0 185 -10 207 -87 8 -28 -18
-88 -43 -102 -13 -7 -89 -11 -194 -11 -95 0 -183 -3 -194 -6 -15 -4 -32 -28
-53 -74 -17 -38 -31 -72 -31 -75 0 -3 116 -5 258 -3 228 3 261 5 292 22 80 43
120 105 128 203 9 121 -37 211 -133 258 -52 26 -68 29 -208 33 -145 5 -151 6
-174 30 -34 37 -32 95 6 133 l29 29 191 0 c189 0 192 0 200 23 5 12 21 48 35
80 l26 57 -238 -1 c-130 0 -248 -4 -262 -8z"
          />
          <path
            d="M8767 3844 c-11 -11 -8 -563 3 -612 25 -109 87 -187 179 -231 51 -24
67 -26 181 -26 153 0 205 19 276 99 78 89 85 128 82 476 l-3 295 -75 0 -75 0
-5 -295 c-5 -290 -5 -296 -29 -337 -34 -60 -85 -83 -183 -83 -67 0 -79 3 -116
30 -76 55 -76 58 -82 390 l-5 295 -70 3 c-39 1 -74 0 -78 -4z"
          />
          <path
            d="M9617 3843 c-4 -3 -7 -199 -7 -435 l0 -429 258 3 c244 3 259 4 299
26 86 45 122 110 123 215 0 81 -18 128 -65 173 -36 33 -36 33 -16 53 41 41 56
83 56 161 0 58 -5 84 -23 118 -29 54 -89 97 -153 111 -54 12 -461 15 -472 4z
m443 -166 c53 -27 63 -114 19 -158 -17 -17 -34 -19 -164 -19 l-145 0 0 95 0
95 133 0 c86 0 141 -5 157 -13z m20 -352 c59 -31 69 -104 21 -157 l-29 -33
-149 0 -148 0 -3 103 -3 102 141 0 c106 0 148 -4 170 -15z"
          />
          <path d="M7403 3830 c16 -5 38 -5 50 0 17 7 10 9 -28 9 -43 -1 -46 -2 -22 -9z" />
          <path
            d="M7335 3757 c-16 -40 -40 -93 -111 -242 -19 -39 -34 -73 -34 -77 0 -3
-29 -66 -64 -140 -93 -196 -146 -309 -146 -314 0 -3 37 -4 82 -2 l82 3 48 110
c54 127 82 190 113 260 12 28 26 61 30 75 4 14 18 41 30 60 12 19 24 44 27 55
3 11 17 46 32 78 14 31 21 57 16 57 -6 0 -10 -5 -10 -11 0 -20 -26 -39 -39
-26 -8 8 -11 5 -11 -12 0 -31 -20 -16 -21 17 -1 21 -3 22 -6 6 -5 -24 17 -85
24 -66 3 6 8 12 13 12 5 0 1 -18 -8 -40 -13 -31 -23 -40 -42 -41 -17 -1 -19
-3 -7 -6 18 -5 23 -18 8 -27 -5 -3 -12 -21 -15 -39 -3 -19 -13 -42 -21 -53
-13 -18 -14 -18 -9 6 5 20 3 22 -5 10 -9 -13 -11 -13 -11 2 0 9 5 20 10 23 6
3 10 12 9 18 0 9 -2 9 -6 0 -7 -20 -43 -16 -43 5 0 14 -2 14 -9 3 -7 -10 -5
-19 6 -26 11 -9 13 -14 5 -19 -16 -10 -32 1 -32 22 0 19 32 107 43 118 4 4 7
18 7 30 0 17 4 22 15 18 8 -4 22 -1 30 6 10 9 15 9 15 1 0 -6 5 -11 10 -11 14
0 12 13 -5 36 -14 19 -15 19 -21 -3 -3 -13 -10 -23 -15 -23 -11 0 -11 6 0 28
5 9 19 43 31 74 12 32 26 55 31 52 5 -3 9 2 9 10 0 32 -19 24 -35 -17z m-137
-383 c-1 -23 -4 -31 -9 -22 -7 13 -2 58 7 58 2 0 3 -16 2 -36z"
          />
          <path
            d="M7546 3734 c8 -20 13 -39 10 -42 -3 -2 -8 2 -12 11 -5 13 -8 13 -25
-4 -23 -23 -24 -30 -4 -23 10 4 15 0 16 -12 0 -15 2 -15 6 -4 10 26 28 31 33
8 3 -12 11 -23 19 -26 9 -3 10 1 3 14 -6 11 -18 38 -28 62 -9 24 -21 45 -25
48 -5 3 -1 -12 7 -32z"
          />
          <path
            d="M7475 3651 c-3 -6 -11 -9 -16 -6 -14 9 -11 -19 6 -41 13 -18 14 -18
8 5 -4 14 -1 26 8 31 7 5 11 12 7 15 -3 4 -9 1 -13 -4z"
          />
          <path d="M7511 3634 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M7600 3611 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
          <path
            d="M7630 3555 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"
          />
          <path
            d="M7512 3500 c18 -43 34 -70 41 -70 14 0 -4 44 -26 65 -13 12 -18 14
-15 5z"
          />
          <path d="M7650 3498 c0 -9 5 -20 10 -23 13 -8 13 5 0 25 -8 13 -10 13 -10 -2z" />
          <path
            d="M7290 3480 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
          />
          <path
            d="M7690 3407 c0 -8 3 -17 6 -20 12 -12 41 -107 33 -107 -5 0 -11 11
-15 24 -7 27 -34 44 -34 21 0 -8 5 -15 10 -15 6 0 10 -7 10 -15 0 -8 -4 -15
-9 -15 -5 0 -12 -11 -15 -25 -8 -32 -20 -32 -35 1 -6 15 -15 24 -18 20 -11
-10 110 -277 130 -288 12 -6 45 -7 83 -3 73 8 74 -9 -5 160 -41 85 -54 106
-62 95 -8 -12 -9 -10 -4 8 4 15 -5 47 -29 97 -35 74 -46 88 -46 62z"
          />
          <path
            d="M4260 3401 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"
          />
          <path d="M7581 3360 c0 -8 4 -22 9 -30 12 -18 12 -2 0 25 -6 13 -9 15 -9 5z" />
          <path
            d="M4290 3337 c0 -2 9 -22 20 -45 11 -22 20 -48 20 -56 0 -8 4 -17 10
-21 5 -3 7 -12 4 -20 -4 -8 -10 -12 -15 -9 -5 3 -9 0 -9 -6 0 -7 -16 -10 -42
-8 -34 2 -43 7 -42 20 1 10 -2 15 -8 12 -11 -7 -4 -32 38 -121 19 -40 34 -77
34 -83 0 -6 32 -10 80 -10 44 0 80 3 80 6 0 13 -160 344 -166 344 -2 0 -4 -1
-4 -3z"
          />
          <path
            d="M7655 3270 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"
          />
          <path
            d="M5345 2720 c-178 -39 -296 -150 -340 -320 -84 -323 217 -604 547
-510 56 16 153 85 197 141 103 130 119 316 40 472 -22 41 -96 121 -145 155
-78 53 -212 81 -299 62z m187 -41 c114 -38 188 -106 242 -219 28 -58 31 -74
31 -160 0 -87 -3 -101 -34 -168 -136 -289 -529 -308 -698 -32 -27 44 -53 144
-53 202 0 91 46 202 113 275 100 109 259 150 399 102z"
          />
          <path
            d="M5329 2587 c-83 -31 -139 -80 -181 -159 -33 -61 -33 -193 -1 -259 28
-56 72 -102 132 -137 41 -24 56 -27 136 -27 80 0 95 3 136 27 96 57 149 139
157 245 8 118 -42 215 -147 283 -42 26 -62 32 -123 36 -47 3 -86 0 -109 -9z
m71 -88 l0 -60 -32 3 c-20 2 -34 9 -36 18 -3 16 47 100 60 100 5 0 8 -27 8
-61z m62 44 c9 -10 23 -33 33 -52 20 -39 11 -54 -31 -49 -28 3 -29 5 -32 61
-3 59 4 69 30 40z m-132 -2 c0 -7 -22 -54 -37 -80 -5 -8 -53 18 -53 29 0 9 67
58 83 59 4 1 7 -3 7 -8z m257 -43 c14 -16 13 -18 -11 -29 -14 -7 -28 -10 -29
-8 -17 22 -44 79 -40 83 7 7 59 -23 80 -46z m-314 -67 c5 -5 2 -33 -5 -62
l-13 -54 -45 0 -45 0 3 40 c2 21 11 52 20 68 14 24 22 28 47 23 16 -4 33 -10
38 -15z m377 -23 c11 -24 20 -56 20 -71 0 -27 -1 -28 -47 -25 -50 3 -50 3 -66
85 -5 28 -3 33 21 42 45 16 52 13 72 -31z m-263 2 c11 0 13 -12 11 -47 l-3
-48 -45 0 c-42 0 -45 2 -48 29 -2 15 -1 40 3 53 5 22 10 25 37 19 17 -3 37 -6
45 -6z m146 -51 l2 -44 -50 0 -50 0 0 45 c0 45 0 45 40 50 22 3 44 3 48 -1 4
-3 9 -26 10 -50z m-264 -131 c12 -55 11 -58 -31 -76 -25 -10 -30 -9 -43 12
-16 24 -35 81 -35 103 0 9 16 13 49 13 l49 0 11 -52z m131 8 c0 -44 0 -44 -41
-51 -22 -4 -43 -5 -46 -1 -3 3 -8 25 -10 51 l-6 45 52 0 51 0 0 -44z m140 32
c0 -7 -5 -30 -11 -51 -10 -37 -11 -38 -52 -35 l-42 3 -3 48 -3 47 55 0 c38 0
56 -4 56 -12z m133 4 c7 -9 -16 -75 -36 -106 -15 -22 -19 -23 -52 -13 -25 7
-34 15 -31 26 3 9 8 35 11 59 l7 42 48 0 c27 0 51 -3 53 -8z m-273 -172 c0
-33 -3 -60 -8 -60 -10 0 -62 80 -62 96 0 7 15 15 33 17 17 2 33 5 35 5 1 1 2
-25 2 -58z m100 31 c0 -21 -40 -83 -57 -89 -9 -3 -13 12 -13 52 l0 56 35 0
c27 0 35 -4 35 -19z m-191 -32 c12 -23 20 -43 19 -45 -6 -6 -81 41 -86 54 -2
6 7 16 20 21 12 6 24 10 24 10 1 1 12 -18 23 -40z m280 22 c10 -7 4 -16 -29
-40 -52 -37 -66 -32 -39 14 21 35 41 43 68 26z"
          />
          <path
            d="M3540 2661 c-84 -29 -121 -51 -171 -102 -60 -61 -95 -137 -108 -229
-17 -128 19 -238 111 -329 71 -71 143 -103 240 -109 108 -6 170 9 246 61 69
48 101 85 140 167 23 49 26 67 26 160 0 98 -2 110 -32 171 -83 172 -287 267
-452 210z m265 -41 c131 -74 198 -188 199 -335 0 -114 -27 -180 -113 -266 -58
-59 -75 -70 -135 -88 -82 -25 -115 -26 -205 -5 -85 19 -161 72 -213 149 -86
128 -76 334 23 448 87 101 171 139 299 134 76 -3 92 -7 145 -37z"
          />
          <path
            d="M3558 2529 c-21 -11 -38 -24 -38 -29 0 -13 0 -13 45 10 50 25 110 25
158 0 29 -16 37 -17 37 -6 0 19 -72 46 -123 46 -23 -1 -59 -10 -79 -21z"
          />
          <path
            d="M3583 2488 c-27 -13 -32 -34 -5 -22 30 13 103 17 115 5 13 -13 37
-15 37 -3 0 27 -104 41 -147 20z"
          />
          <path
            d="M3613 2450 c-13 -5 -23 -14 -23 -20 0 -7 8 -9 23 -4 12 4 27 7 32 7
6 0 20 -3 33 -7 35 -11 26 11 -9 23 -18 6 -32 11 -33 10 -1 0 -11 -4 -23 -9z"
          />
          <path
            d="M3454 2313 c7 -87 6 -93 -11 -93 -31 0 -43 -21 -43 -71 0 -42 4 -50
31 -70 26 -18 35 -20 50 -11 27 17 303 16 329 0 15 -9 23 -10 28 -2 4 6 15 13
25 17 13 5 17 18 17 60 0 29 -5 58 -12 65 -8 8 -47 12 -109 12 l-97 0 -5 43
c-6 42 -4 72 9 115 5 18 3 22 -18 22 -24 0 -24 0 -20 -90 l4 -91 -78 3 -79 3
-5 82 c-3 45 -9 85 -14 90 -5 4 -6 -32 -2 -84z m34 -165 c-3 -7 -11 -13 -18
-13 -7 0 -15 6 -17 13 -3 7 4 12 17 12 13 0 20 -5 18 -12z m52 -3 c0 -8 -7
-15 -15 -15 -8 0 -15 7 -15 15 0 8 7 15 15 15 8 0 15 -7 15 -15z m180 0 c0 -8
-4 -15 -10 -15 -5 0 -10 7 -10 15 0 8 5 15 10 15 6 0 10 -7 10 -15z m58 4 c-2
-6 -8 -10 -13 -10 -5 0 -11 4 -13 10 -2 6 4 11 13 11 9 0 15 -5 13 -11z m52
-5 c0 -17 -22 -14 -28 4 -2 7 3 12 12 12 9 0 16 -7 16 -16z"
          />
          <path
            d="M7060 2671 c-19 -4 -44 -13 -55 -20 -20 -12 -20 -12 0 -6 11 3 41 11
67 16 27 6 48 13 48 15 0 5 -15 4 -60 -5z"
          />
          <path
            d="M7150 2672 c40 -14 128 -23 109 -12 -9 5 -43 12 -75 15 -39 3 -50 2
-34 -3z"
          />
          <path
            d="M7321 2618 c149 -107 195 -195 187 -356 -4 -70 -10 -98 -32 -141 -33
-63 -107 -141 -162 -169 -185 -92 -406 -22 -505 160 -33 61 -34 66 -34 178 0
108 2 118 28 165 32 56 96 127 142 157 27 18 28 19 5 12 -56 -15 -124 -83
-164 -162 -72 -145 -53 -312 50 -430 90 -102 175 -142 309 -142 92 0 137 13
212 62 166 107 227 318 143 494 -34 70 -108 149 -169 182 -60 31 -64 28 -10
-10z"
          />
          <path
            d="M7280 2516 c0 -5 6 -17 14 -25 8 -9 22 -30 31 -46 l17 -30 -7 30 c-6
28 -55 91 -55 71z"
          />
          <path
            d="M6974 2496 c-25 -27 -44 -83 -44 -128 0 -49 31 -128 50 -128 15 0 12
16 -4 29 -8 7 -19 34 -26 60 -13 53 0 120 28 154 17 19 13 32 -4 13z"
          />
          <path
            d="M7240 2463 c0 -6 5 -15 11 -18 6 -4 14 -17 19 -29 6 -15 9 -16 9 -5
1 9 -8 27 -19 40 -10 13 -19 19 -20 12z"
          />
          <path
            d="M7101 2388 c-6 -16 -5 -30 5 -45 19 -31 19 -31 -27 -186 -23 -76 -39
-141 -36 -144 3 -3 26 4 51 16 l45 22 42 -20 c24 -12 47 -17 51 -13 5 5 -10
68 -32 140 -40 132 -49 182 -30 182 17 0 12 57 -6 64 -31 12 -55 6 -63 -16z
m49 -173 c5 -14 13 -37 16 -52 6 -22 5 -24 -12 -15 -11 5 -24 8 -30 5 -7 -2
-7 10 0 42 6 25 12 45 14 45 1 0 7 -11 12 -25z m29 -122 c26 -32 20 -41 -15
-23 -21 12 -29 12 -46 1 -25 -16 -31 -10 -22 23 9 36 55 36 83 -1z"
          />
          <path
            d="M7342 2380 c-1 -19 -13 -59 -27 -87 -13 -29 -20 -53 -15 -53 19 0 51
89 47 132 -3 39 -4 40 -5 8z"
          />
          <path d="M6992 2375 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
          <path d="M7231 2374 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M7281 2364 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M915 2350 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"
          />
          <path
            d="M9985 2350 c-26 -10 -52 -40 -36 -40 6 0 20 9 30 19 13 13 28 18 43
14 18 -4 20 -3 8 6 -17 12 -18 12 -45 1z"
          />
          <path d="M7271 2324 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M4190 2316 c-35 -43 28 -99 70 -61 24 22 25 38 4 59 -19 20 -58 21
-74 2z"
          />
          <path
            d="M4448 2319 c-23 -13 -23 -42 0 -62 24 -22 38 -21 62 3 24 24 25 34 4
54 -18 18 -41 20 -66 5z"
          />
          <path
            d="M4708 2319 c-26 -14 -22 -46 7 -65 23 -15 27 -15 50 0 29 19 32 38 9
60 -18 18 -41 20 -66 5z"
          />
          <path
            d="M6045 2317 c-22 -17 -14 -62 13 -69 31 -8 62 9 62 35 0 43 -38 60
-75 34z"
          />
          <path
            d="M6286 2317 c-23 -17 -18 -45 11 -64 19 -13 24 -12 42 6 25 25 26 35
5 55 -19 19 -35 20 -58 3z"
          />
          <path
            d="M6528 2319 c-27 -15 -23 -57 7 -71 35 -16 75 3 75 35 0 42 -41 60
-82 36z"
          />
          <path d="M872 2285 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
          <path
            d="M9990 2298 c0 -8 -6 -21 -14 -28 -12 -9 -17 -7 -28 9 l-13 21 -1107
0 c-1027 0 -1108 -1 -1108 -17 0 -15 79 -16 1110 -9 761 4 1110 3 1110 -4 0
-21 41 -50 70 -50 23 0 35 7 50 32 10 18 17 35 13 38 -3 3 -8 -1 -10 -8 -8
-21 -45 -52 -62 -52 -14 0 -14 1 -1 10 10 6 11 10 3 10 -7 0 -13 6 -13 14 0 8
6 16 13 19 10 4 10 7 0 18 -11 11 -13 10 -13 -3z"
          />
          <path
            d="M1030 2288 c0 -5 417 -9 928 -10 510 -1 969 -2 1021 -2 72 -1 95 2
99 13 4 12 -152 13 -1022 10 -564 -2 -1026 -7 -1026 -11z"
          />
          <path
            d="M7245 2290 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path d="M919 2226 c13 -5 29 -5 42 0 17 8 13 9 -21 9 -34 0 -38 -1 -21 -9z" />
          <path
            d="M2504 1548 c-24 -11 -44 -48 -44 -79 0 -52 81 -87 126 -55 24 18 10
34 -16 18 -27 -17 -37 -15 -60 8 -44 44 -12 96 52 86 41 -7 51 6 19 24 -24 12
-49 12 -77 -2z"
          />
          <path
            d="M2751 1546 c-69 -38 -40 -146 39 -146 72 0 109 96 54 139 -31 24 -59
26 -93 7z m77 -28 c37 -37 -12 -113 -57 -88 -26 13 -36 52 -21 79 12 24 58 29
78 9z"
          />
          <path
            d="M2990 1479 c0 -60 3 -80 13 -76 8 2 11 18 9 44 -2 23 0 43 5 46 5 3
24 -17 42 -44 50 -72 61 -66 61 32 0 60 -3 80 -12 77 -7 -3 -15 -26 -18 -52
l-5 -47 -39 50 c-21 28 -42 51 -47 51 -5 0 -9 -36 -9 -81z"
          />
          <path
            d="M3250 1480 c0 -89 17 -110 22 -27 l3 52 39 -53 c21 -29 44 -51 50
-49 16 5 15 149 -1 155 -9 2 -13 -11 -13 -47 0 -28 -3 -51 -7 -51 -5 0 -23 23
-41 50 -17 28 -37 50 -42 50 -6 0 -10 -34 -10 -80z"
          />
          <path
            d="M3507 1554 c-4 -4 -7 -40 -7 -81 l0 -73 56 0 c64 0 73 23 11 28 -29
3 -37 7 -37 23 0 15 7 19 35 19 19 0 35 5 35 10 0 6 -16 10 -35 10 -28 0 -35
4 -35 20 0 17 7 20 41 20 28 0 39 4 37 13 -5 13 -89 22 -101 11z"
          />
          <path
            d="M3764 1548 c-23 -11 -44 -48 -44 -77 0 -10 9 -30 21 -45 16 -20 29
-26 59 -26 20 0 43 6 49 14 16 19 -3 30 -29 16 -39 -21 -80 23 -65 70 7 22 43
35 73 25 27 -8 37 11 13 24 -24 13 -49 13 -77 -1z"
          />
          <path
            d="M3967 1554 c-10 -11 3 -24 23 -24 16 0 19 -9 22 -62 2 -38 8 -63 16
-66 9 -3 12 14 12 62 0 59 2 66 20 66 11 0 20 7 20 15 0 11 -13 15 -53 15 -30
0 -57 -3 -60 -6z"
          />
          <path
            d="M4827 1554 c-13 -13 -7 -24 13 -24 17 0 20 -7 21 -47 2 -71 3 -76 17
-80 9 -4 12 13 12 60 0 58 2 66 20 69 12 2 22 8 23 13 2 11 -95 20 -106 9z"
          />
          <path
            d="M5067 1553 c-4 -3 -7 -40 -7 -80 0 -55 3 -74 13 -71 6 3 13 17 15 31
4 36 23 34 45 -3 27 -45 52 -36 27 10 -7 13 -6 21 5 30 22 18 18 57 -7 74 -23
16 -79 22 -91 9z m78 -48 c0 -14 -8 -21 -27 -23 -24 -3 -28 0 -28 23 0 23 4
26 28 23 19 -2 27 -9 27 -23z"
          />
          <path
            d="M5330 1485 c-32 -73 -33 -113 -3 -67 21 30 79 31 88 2 6 -17 35 -30
35 -14 0 15 -70 154 -78 154 -5 0 -24 -34 -42 -75z m60 -12 c0 -7 -9 -13 -20
-13 -23 0 -24 4 -9 32 9 17 13 18 20 7 5 -8 9 -20 9 -26z"
          />
          <path
            d="M5577 1553 c-4 -3 -7 -39 -7 -80 0 -57 3 -73 14 -73 11 0 16 14 18
50 l3 50 35 -47 c53 -71 60 -68 60 26 0 89 -17 112 -22 29 l-3 -53 -40 52
c-41 53 -47 58 -58 46z"
          />
          <path
            d="M5846 1544 c-29 -28 -20 -54 24 -71 27 -11 40 -22 38 -32 -4 -17 -30
-19 -62 -6 -14 6 -17 4 -14 -11 2 -14 13 -20 41 -22 45 -4 67 11 67 45 0 19
-8 28 -40 40 -52 21 -55 48 -5 40 40 -7 51 16 13 27 -35 9 -45 7 -62 -10z"
          />
          <path
            d="M6067 1554 c-4 -4 -7 -40 -7 -81 0 -58 3 -73 15 -73 10 0 15 11 15
35 0 33 2 35 35 35 19 0 35 5 35 10 0 6 -16 10 -35 10 -28 0 -35 4 -35 19 0
16 8 20 38 23 20 2 37 8 37 13 0 12 -87 19 -98 9z"
          />
          <path
            d="M6290 1481 l0 -81 49 0 c50 0 74 13 45 24 -9 3 -29 6 -46 6 -43 0
-35 34 10 38 17 2 32 7 32 12 0 5 -15 10 -32 12 -22 2 -34 9 -36 21 -3 14 4
17 38 17 59 0 47 24 -13 28 l-47 3 0 -80z"
          />
          <path
            d="M6520 1480 c0 -47 4 -80 10 -80 6 0 10 11 10 24 0 39 20 42 49 7 34
-41 56 -42 33 -2 -15 28 -15 31 1 49 22 24 22 37 -3 62 -13 13 -33 20 -60 20
l-40 0 0 -80z m85 40 c10 -17 -16 -41 -39 -38 -13 2 -22 12 -24 26 -3 19 1 22
27 22 16 0 33 -5 36 -10z"
          />
          <path
            d="M7457 1553 c-20 -5 -47 -52 -47 -83 0 -56 96 -93 133 -52 19 20 23
61 7 63 -38 4 -54 2 -58 -9 -2 -7 5 -12 17 -12 27 0 27 -16 0 -30 -30 -17 -69
11 -69 49 0 40 22 55 70 47 43 -7 54 6 21 24 -20 10 -42 11 -74 3z"
          />
          <path
            d="M7687 1553 c-4 -3 -7 -39 -7 -80 0 -58 3 -73 15 -73 10 0 15 10 15
30 0 40 25 40 48 0 9 -16 23 -30 30 -30 16 0 15 11 -3 37 -13 18 -13 22 0 33
22 18 18 57 -7 74 -23 16 -79 22 -91 9z m81 -45 c-2 -17 -11 -24 -30 -26 -24
-3 -28 0 -28 22 0 22 4 26 31 26 26 0 30 -3 27 -22z"
          />
          <path
            d="M7946 1539 c-55 -43 -24 -139 45 -139 42 0 64 14 79 50 32 77 -57
141 -124 89z m88 -25 c19 -19 20 -44 4 -66 -16 -20 -36 -24 -65 -14 -23 7 -28
21 -24 61 3 36 56 48 85 19z"
          />
          <path
            d="M8188 1555 c-3 -3 4 -38 17 -78 27 -90 48 -99 65 -28 7 28 15 49 20
46 4 -2 13 -25 19 -50 16 -65 35 -58 60 24 24 80 26 94 9 89 -7 -3 -17 -24
-23 -47 -5 -23 -14 -43 -19 -44 -4 -1 -16 18 -25 43 -9 25 -21 45 -26 45 -5 0
-16 -21 -24 -47 -8 -27 -17 -48 -21 -48 -3 0 -12 23 -19 50 -12 47 -20 58 -33
45z"
          />
          <path
            d="M6997 1513 c-4 -3 -7 -19 -7 -34 0 -31 28 -53 54 -43 22 8 31 51 16
69 -13 15 -51 20 -63 8z"
          />
          <path d="M4427 1486 c-3 -8 0 -19 7 -25 10 -9 12 -6 8 14 -5 29 -8 31 -15 11z" />
          <path
            d="M4472 1454 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
